/**
 * Shared contrast for Apps lead magnets on the #0A0A0A page.
 *
 * PR #9 moved only the landing card from #121212 to #1A1A1A. That step
 * still disappears into the page. This panel is a lifted graphite
 * (top #4A4A54, bottom #2E2E36, above the #2A2A2E floor) with an inner
 * highlight, a light edge, and a cyan ring so a screenshot next to the
 * black page is obvious. Fields sit in a darker well. Cyan #00AEEF
 * stays on the submit button.
 */

export const LEAD_CARD_CLASS =
  "bg-[linear-gradient(180deg,#4A4A54_0%,#3A3A42_38%,#2E2E36_100%)] border border-white/25 shadow-[inset_0_1px_0_rgba(255,255,255,0.38),0_0_0_1px_rgba(0,174,239,0.7),0_0_36px_rgba(0,174,239,0.5),0_0_80px_rgba(0,174,239,0.28)]";

/** Input / Textarea component override. Those already set border, radius, and padding. */
export const LEAD_FIELD_CLASS =
  "bg-[#121216] border-white/20 shadow-none text-white placeholder:text-gray-200 focus:border-[#00AEEF] focus-visible:border-[#00AEEF] focus-visible:ring-[#00AEEF]";

/** Native textarea and select, which do not get the component chrome. */
export const LEAD_TEXTAREA_CLASS =
  "w-full bg-[#121216] border border-white/20 text-white placeholder:text-gray-200 rounded-md px-4 py-2.5 text-sm outline-none focus:border-[#00AEEF] focus:ring-1 focus:ring-[#00AEEF] transition-colors resize-none";

export const LEAD_SELECT_CLASS =
  "w-full bg-[#121216] border border-white/20 text-gray-200 rounded-md px-4 py-2.5 text-sm outline-none focus:border-[#00AEEF] focus:ring-1 focus:ring-[#00AEEF] transition-colors";

export const LEAD_LABEL_CLASS = "text-gray-200 text-sm";

export const LEAD_SUBCOPY_CLASS = "text-gray-200 text-sm";

export const LEAD_TRUST_CLASS =
  "text-xs text-gray-200 leading-relaxed text-center";
